// TSS vite/03 §"Query keys convention".

export const projectedCrossKeys = {
    all:      ['projected-crosses'],
    list:     (filters) => ['projected-crosses', 'list', filters],
    infinite: (filters, limit) => ['projected-crosses', 'list', 'infinite', filters, limit],
    queues:   (donorId) => ['projected-crosses', 'queues', donorId],
};
